import { ActionBase } from '../../../core/store/action/ActionBase';
import { SupportTicketModel } from '../../models/SupportTicketModel';

export const SUBMIT_SUPPORT_TICKET_SUCCESS_ACTION = '[Configuration] Submit Support Ticket Success Action';

export class SubmitSupportTicketSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = SUBMIT_SUPPORT_TICKET_SUCCESS_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/SubmitSupportTicketSuccessAction.ts